angular
  .module("akitabox.ui.dialogs")
  .service("ConfirmationDialog", ConfirmationDialog);

/* @ngInject */
function ConfirmationDialog($mdDialog, $mdMedia) {
  const modalOptions = {
    templateUrl:
      "app/core/ui/dialogs/confirmation/confirmation.dialog.template.html",
    controller: "ConfirmationDialogController",
    controllerAs: "vm",
    bindToController: true,
    parent: angular.element(document.body),
    closeTo: angular.element(document.body),
    clickOutsideToClose: false,
    escapeToClose: false,
    focusOnOpen: false,
    multiple: true,
  };

  // Enable fullscreen mode while on mobile
  if ($mdMedia("sm") || $mdMedia("xs")) {
    modalOptions.fullscreen = true;
  }

  return { show };

  // ------------------------
  //   Public Functions
  // ------------------------

  /**
   * Show dialog
   *
   * @param { object } options Dialog options
   * @param { object } options.locals Locals for the dialog controller. See
   *    dialog controller for detailed documentation of locals.
   * @param { () => Promise<any> } options.locals.onConfirm Callback invoked
   *    when the dialog is confirmed. Reject to keep the dialog open,
   *    resolve to close the dialog and resolve the `show` promise
   *    with its result.
   * @param { string } options.locals.title
   * @param { string } options.locals.prompt
   * @param { boolean } [options.locals.isDestructive=true]
   * @param { string } [options.locals.confirmText="Confirm"]
   * @param { string } options.locals.customClass
   * @return {Promise<any>} Promise that resolves with the result of
   *    `onConfirm`. Rejects if the dialog is cancelled.
   */
  function show(options) {
    var dialogOptions = {
      ...modalOptions,
      ...options,
      locals: {
        isDestructive: true,
        confirmText: "Confirm",
        ...options.locals,
      },
    };
    return $mdDialog.show(dialogOptions);
  }
}
